import script from "./ContainerBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContainerBox.vue?vue&type=script&lang=ts&setup=true"

import "./ContainerBox.vue?vue&type=style&index=0&id=d20ebbdc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1212641435/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d20ebbdc"]])

export default __exports__